import { ILogger } from '@cian/logger';

import { ChatMessageValidationError, ChatOfferValidationError, ChatUsersValidationError } from '../errors';
import { IChat } from '../types/chatList';
import { EExceptionDomain } from '../types/exceptionDomains';

interface IValidateChatItemParameters {
  chat?: IChat;
  logger?: ILogger;
}

export function validateChatItem({ chat, logger }: IValidateChatItemParameters): boolean {
  try {
    if (!chat) {
      throw new ChatOfferValidationError({
        message: 'В чате отсутствуют корректные данные (chat is undefined)',
        domain: EExceptionDomain.Chat,
      });
    }

    if (!chat.lastMessage) {
      throw new ChatMessageValidationError({
        message: `В чате отсутствует поле lastMessage, chatId: ${chat.chatId}`,
        domain: EExceptionDomain.Chat,
        details: {
          chatId: chat.chatId,
        },
      });
    }

    if (!('userId' in chat.lastMessage)) {
      throw new ChatMessageValidationError({
        message: `В чате отсутствует поле lastMessage.userId, chatId: ${chat.chatId}`,
        domain: EExceptionDomain.Chat,
        details: {
          chatId: chat.chatId,
          messageId: chat.lastMessage['messageId'],
        },
      });
    }

    // поле теxt может быть необязательным, если это сообщение с вложением
    if (!('text' in chat.lastMessage) && !['offer', 'textAndFiles'].includes(chat.lastMessage.type)) {
      throw new ChatMessageValidationError({
        message: `В чате отсутствует поле lastMessage.text, chatId: ${chat.chatId}, message.type: ${chat.lastMessage['type']}`,
        domain: EExceptionDomain.Chat,
        details: {
          chatId: chat.chatId,
          messageId: chat.lastMessage['messageId'],
        },
      });
    }

    if (!chat.users) {
      throw new ChatUsersValidationError({
        message: `В чате отсутствует поле users, chatId: ${chat.chatId}`,
        domain: EExceptionDomain.Chat,
        details: {
          chatId: chat.chatId,
        },
      });
    }

    return true;
  } catch (error) {
    if (logger) {
      logger.error(error);
    } else {
      console.error(error);
    }

    return false;
  }
}
